import React from "react";
import { Box, Typography, TextField, Stack } from "@mui/material";

export default function BasicInfoSection({ formData, handleChange, isOrg }) {
  return (
    <Box id="basic-info" sx={{ mb: 4, scrollMarginTop: "88px" }}>
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#111", mb: 2 }}>
        Basic Information
      </Typography>
      <Stack spacing={2.5}>
        {!isOrg && (
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField
              fullWidth
              label="First Name"
              value={formData.first_name || ""}
              onChange={handleChange("first_name")}
              variant="outlined"
              size="small"
            />
            <TextField
              fullWidth
              label="Last Name"
              value={formData.last_name || ""}
              onChange={handleChange("last_name")}
              variant="outlined"
              size="small"
            />
          </Stack>
        )}
        
        <TextField
          fullWidth
          label="Username"
          value={formData.username || ""}
          onChange={handleChange("username")}
          variant="outlined"
          size="small"
        />
        
        <TextField
          fullWidth
          label="Short Bio"
          multiline
          rows={4}
          value={formData.bio || ""}
          onChange={handleChange("bio")}
          variant="outlined"
          size="small"
          placeholder="Tell us a bit about yourself..."
          helperText={`${(formData.bio || "").length}/500 characters max`}
          inputProps={{ maxLength: 500 }}
        />
      </Stack>
    </Box>
  );
}